/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 */

export default [
  {
    id: 1,
    label: 'Email',
    field_name: 'email',
    source_field: 'email',
    customClass: 'email',
    showColumn: true,
    pinned: true,
  },
  {
    id: 2,
    label: 'First Name',
    field_name: 'first_name',
    source_field: 'first_name',
    showColumn: true,
    pinned: true,
  },
  {
    id: 3,
    label: 'Last Name',
    field_name: 'last_name',
    source_field: 'last_name',
    showColumn: true,
    pinned: true,
  },
  {
    id: 4,
    label: 'Group Name',
    field_name: 'group_name',
    source_field: 'group_name',
    showColumn: true,
  },
  {
    id: 5,
    label: 'External User Id',
    field_name: 'external_user_id',
    source_field: 'external_user_id',
    showColumn: true,
  },
  {
    id: 6,
    label: 'Unit',
    field_name: 'unit',
    source_field: 'unit_name',
    showColumn: true,
  },
  {
    id: 7,
    label: 'Unit Status',
    field_name: 'status',
    source_field: 'status',
    showColumn: true,
  },
  {
    id: 8,
    label: 'Unit Achievement Test Score',
    field_name: 'achievement_test_score',
    source_field: 'achievement_test_score',
    showColumn: true,
  },
  {
    id: 9,
    label: 'Achievement Test Status',
    field_name: 'achievementTestStatus',
    source_field: 'achievement_test_status',
    showColumn: true,
  },
  {
    id: 10,
    label: 'Lesson Progress',
    field_name: 'lessonProgress',
    source_field: 'completed_lessons_count',
    showColumn: true,
  },
  {
    id: 11,
    label: 'Date Started',
    field_name: 'date_started',
    source_field: 'date_started',
    showColumn: true,
  },
  {
    id: 12,
    label: 'Date Completed',
    field_name: 'date_completed',
    source_field: 'date_completed',
    showColumn: true,
  },
  {
    id: 13,
    label: 'Unit Score',
    field_name: 'unit_score',
    source_field: 'unit_score',
    showColumn: true,
  },
  {
    id: 14,
    label: 'Grammar Score',
    field_name: 'grammar_score',
    source_field: 'grammar_score',
    showColumn: true,
  },
  {
    id: 15,
    label: 'Reading Score',
    field_name: 'reading_score',
    source_field: 'reading_score',
    showColumn: true,
  },
  {
    id: 16,
    label: 'Listening Score',
    field_name: 'listening_score',
    source_field: 'listening_score',
    showColumn: true,
  },
  {
    id: 17,
    label: 'Speaking Score',
    field_name: 'speaking_score',
    source_field: 'speaking_score',
    showColumn: true,
  },
  {
    id: 18,
    label: 'Writing Score',
    field_name: 'writing_score',
    source_field: 'writing_score',
    showColumn: true,
  },
  {
    id: 19,
    label: 'Vocabulary Score',
    field_name: 'vocabulary_score',
    source_field: 'vocabulary_score',
    showColumn: true,
  },
  {
    id: 20,
    label: 'Smart Unit',
    field_name: 'smart',
    source_field: 'smart',
    showColumn: true,
  },
];
